export default __webpack_public_path__ + "static/media/pencil.f2b2c7f5.svg";